/* eslint-disable no-param-reassign */
import React, { useEffect, useState, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { oneOf, string, node, bool, object, func } from 'prop-types';
import setClass from '../../common/set-class';
const noop = (v) => v;
const getCssVar = (domNode, propName) => {
    if (domNode) {
        return getComputedStyle(domNode).getPropertyValue(propName);
    }
    return 0;
};
const getSlideAnimDur = (domNode) => 
// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | 0' is not assignable to... Remove this comment to see the full error message
Number.parseFloat(getCssVar(domNode, '--b-side-panel-default-duration'));
const getOverlayAnimDur = () => Number.parseFloat(
// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | 0' is not assignable to... Remove this comment to see the full error message
getCssVar(document.body, '--b-side-panel-overlay-duration'));
const removeBodyClass = (panelNode) => {
    const totalAnimDur = getSlideAnimDur(panelNode) + getOverlayAnimDur();
    document.body.classList.remove('b-body-panel-open--fadein');
    window.setTimeout(() => {
        document.body.classList.remove('b-body-panel-open');
    }, totalAnimDur / 2);
};
const addBodyClass = () => {
    document.body.classList.add('b-body-panel-open');
    window.setTimeout(() => {
        document.body.classList.add('b-body-panel-open--fadein');
    }, 0);
};
const animateIn = (panelNode, opts = {}) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onStart' does not exist on type '{}'.
    const { onStart = noop, onEnd = noop } = opts;
    panelNode.style.display = 'block';
    onStart(panelNode);
    addBodyClass();
    window.setTimeout(() => {
        panelNode.classList.add('b-side-panel--slidein');
    }, getOverlayAnimDur() / 2);
    window.setTimeout(() => {
        onEnd(panelNode);
    }, getSlideAnimDur(panelNode));
};
const animateOut = (panelNode, opts = {}) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onStart' does not exist on type '{}'.
    const { onStart = noop, onEnd = noop } = opts;
    const slideAnimDur = getSlideAnimDur(panelNode);
    const totalAnimDur = getSlideAnimDur(panelNode) + getOverlayAnimDur();
    onStart(panelNode);
    removeBodyClass(panelNode);
    panelNode.classList.remove('b-side-panel--slidein');
    window.setTimeout(() => {
        panelNode.style.display = 'none';
    }, slideAnimDur + 50);
    window.setTimeout(() => {
        onEnd(panelNode);
    }, totalAnimDur);
};
const SidePanel = (props) => {
    const { className, style, children, isVisible, onOpen, onOpenEnd, onClose, onCloseEnd, size, } = props;
    const isTriggered = useRef(0);
    const [sidePanelNode, setSidePanelNode] = useState();
    const wrapper = useCallback((wrapperNode) => {
        if (wrapperNode !== null) {
            setSidePanelNode(wrapperNode);
        }
    }, []);
    /* handle open/close logic and animation given a state variable
     * from the parent.
     */
    useEffect(() => {
        if (sidePanelNode) {
            if (isVisible) {
                animateIn(sidePanelNode, { onStart: onOpen, onEnd: onOpenEnd });
            }
            else if (isTriggered.current) {
                animateOut(sidePanelNode, { onStart: onClose, onEnd: onCloseEnd });
            }
        }
    }, [isVisible, sidePanelNode]);
    /* hacky way to know if the side panel has ever been trigerred */
    useEffect(() => {
        if (isVisible) {
            isTriggered.current += 1;
        }
    }, [isVisible]);
    /* remove body class if the panel happens to be open when it gets unmounted */
    useEffect(() => () => {
        // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
        removeBodyClass();
    }, []);
    return ReactDOM.createPortal(React.createElement("div", { tabIndex: -1, ref: wrapper, style: style, className: setClass([
            'b-side-panel-hook',
            'b-side-panel',
            size === 'wide' ? 'b-side-panel--wide' : '',
            size === 'super-wide' ? 'b-side-panel--super-wide' : '',
            className,
        ]) }, children), document.body);
};
SidePanel.propTypes = {
    className: string,
    children: node,
    isVisible: bool,
    style: object,
    onOpen: func,
    size: oneOf(['default', 'wide', 'super-wide']),
};
SidePanel.defaultProps = {
    isVisible: false,
    onOpen: () => { },
    onClose: () => { },
    onOpenEnd: () => { },
    onCloseEnd: () => { },
    size: 'default',
};
export default SidePanel;
